import { SelectField } from '@almbrand/selectfield';
import { usePreventScrollPropagation } from '@almbrand/snapscroller';
import { useRef } from 'react';

export interface SelectListFieldProps {
	options: { key: string; value: string }[];
	placeholder?: string;
	isSearchable?: boolean;
	fieldName: string;
	errorMessage: string;
	register: any;
	submitQuestion?: () => void;
}

export const SelectListField: React.FC<SelectListFieldProps> = ({
	options,
	isSearchable = true,
	placeholder,
	fieldName,
	errorMessage,
	register,
	submitQuestion,
}) => {
	const selectContainerRef = useRef<HTMLDivElement>(null);

	usePreventScrollPropagation(selectContainerRef, false);

	const mappedOptions = options
		.filter((opt) => opt.key && opt.value)
		.map((opt) => ({
			label: opt.key,
			value: opt.value,
		}));

	const { onChange, name } = register(fieldName, {
		required: true,
	});

	const handleChange = (selected: { label: string; value: string } | null) => {
		if (!selected) return;

		onChange({
			target: {
				name,
				value: {
					label: selected.label,
					value: selected.value,
				},
			},
		});

		submitQuestion?.();
	};

	return (
		<div ref={selectContainerRef}>
			<SelectField
				icon={{ isIcon: false }}
				options={mappedOptions}
				isSearchable={isSearchable}
				onChange={handleChange}
				placeHolder={placeholder}
				errorMessage={errorMessage}
			/>
		</div>
	);
};
